import BaseObject from '../../../base/base_object';
import {
    BLUE_RIBBON_NATIVE_EVENTS,
    IBlueRibbonNativeEvents,
    GameDetailsChangedEvent, 
    GameStatusChangedEvent,
    ComplexMatchDetails,
    OptEvent,
    PotStateChangedEvent,
    WinEvent,
    GameObject
} from '../blue_ribbon_api_interfaces';
import {BlueRibbonExecutionMonitor} from '../blue_ribbon_helpers';
import {IBlueRibbonEventsHandler} from './blue_ribbon_event_handler_interface';

type BlueRibbonEventListenerCallback = (data: any) => void;

type CustomBlueRibbonEventName = 'onConnected' | 'onGamesFeedStarted';

export class BlueRibbonEventsDispatcher extends BaseObject {
    static CLASS = "BlueRibbonEventsDispatcher";

    constructor(private _blueRibbonNativeEvents: IBlueRibbonNativeEvents,
                private _executionMonitor: BlueRibbonExecutionMonitor,
                private  readonly _eventsHandlers: IBlueRibbonEventsHandler[]) {
        super();
        this._addNativeBlueRibbonListener<OptEvent>('OPT_IN_EVENT',
            (handler, data) => handler.onOptIn(data));
        this._addNativeBlueRibbonListener<OptEvent>('OPT_OUT_EVENT',
            (handler, data) => handler.onOptOut(data));
        this._addNativeBlueRibbonListener<GameDetailsChangedEvent>('GAME_DETAILS_CHANGED_EVENT',
            (handler, data) => handler.onGameDetailsChanged(data));
        this._addNativeBlueRibbonListener<GameStatusChangedEvent>('GAME_STATUS_CHANGED_EVENT',
            (handler, data) => handler.onGameStatusChanged(data));
        this._addNativeBlueRibbonListener<GameStatusChangedEvent>('GAME_STATUS_CHANGED_EVENT',
            (handler, data) => handler.onGameStatusChanged(data));
        this._addNativeBlueRibbonListener<PotStateChangedEvent>('POT_STATE_CHANGED_EVENT',
            (handler, data) => handler.onPotStateChanged(data));
        this._addNativeBlueRibbonListener<WinEvent>('WIN_EVENT',
            (handler, data) => handler.onWin(data));

        this._addCustomEventListener<ComplexMatchDetails[]>('onConnected',
            (handler, data) => handler.onConnected(data));

        this._addCustomEventListener<GameObject[]>('onGamesFeedStarted',
            (handler, data) => handler.onGamesFeedStarted(data));
    }

    private _isDisposed = false;
    dispose() {
        this._isDisposed = true;
        this._eventsHandlers.forEach(h => h.dispose());
    }


    private _addNativeBlueRibbonListener<TEventData>(eventName: BLUE_RIBBON_NATIVE_EVENTS, callback: (eventsHandler: IBlueRibbonEventsHandler, data: TEventData) => void): void {

        this._blueRibbonNativeEvents.on(eventName, (data) => {
            if(this._isDisposed) {
                this._executionMonitor.error(`Received ${eventName} event for disposed blue ribbon events dispatcher`);
                return;
            }

            this._executionMonitor.eventReceived(eventName, data);

            this._eventsHandlers.forEach(handler => {
                try {
                    callback(handler, data)
                } catch (err) {
                    this._executionMonitor.error(`Callback for blue ribbon event failed! EventName: ${eventName}; handler: ${handler}`, err);
                }

            })
        });
    }

    private _customEventsListeners: Record<string, Array<BlueRibbonEventListenerCallback>> = {};

    fireOnConnected(data: ComplexMatchDetails[]) {
        this._fireCustomEvent('onConnected', data);
    }

    fireOnGamesFeedStarted(data: GameObject[]) {
        this._fireCustomEvent('onGamesFeedStarted', data);
    }

    private _addCustomEventListener<TEventData>(eventName: CustomBlueRibbonEventName, callback: (handler: IBlueRibbonEventsHandler, data: TEventData) => void): void {
        if(!this._customEventsListeners[eventName]) {
            this._customEventsListeners[eventName] = [];
        }

        this._customEventsListeners[eventName].push((data) => {
            this._eventsHandlers.forEach(handler => {
                try {
                    callback(handler, data);
                } catch (err) {
                    this._executionMonitor.error(`Callback for custom blue ribbon event failed! EventName: ${eventName}; handler: ${handler}`, err);
                }

            })
        });
    }

    private _fireCustomEvent(eventName: CustomBlueRibbonEventName, data: any): void {
        if(!this._customEventsListeners[eventName]) {
            return;
        }

        this._customEventsListeners[eventName].forEach(callBack => {
            try {
                callBack(data);
            } catch (ex) {
                this._executionMonitor.error(`Callback for custom blue ribbon event failed! EventName: ${eventName}; Callback: ${callBack}`, ex);
            }

        });
    }

}
